<script lang="ts" setup>
import type { ICellRendererParams } from 'ag-grid-community';
import type { PropType} from 'vue';
import { computed } from 'vue';

type ExtendedParams = ICellRendererParams & {
    id: string;
    title: (params: ICellRendererParams) => string;
    icon: (params: ICellRendererParams) => string;
    cssClass: (params: ICellRendererParams) => string;
};

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const title = computed(() => (typeof props.params.title === 'function' ? props.params.title(props.params) : props.params.title));
const icon = computed(() => (typeof props.params.icon === 'function' ? props.params.icon(props.params) : props.params.icon));
const cssClass = computed(() => (typeof props.params.icon === 'function' ? props.params.cssClass(props.params) : props.params.cssClass));
</script>

<template>
    <div class="flex-container align-middle height-100">
        <div class="sy-simple-text-icon flex-container align-middle height-100"><Icon v-if="icon" :icon="icon" :class="[cssClass]" /></div> {{ title }}
    </div>
</template>

<style>
    /* this is to make the group align with icon text */
    .sy-simple-text-icon {
        width: 34px;
    }
</style>
